"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    LoadingStateContext: ()=>LoadingStateContext_js_namespaceObject.LoadingStateContext,
    StandaloneStyleProvider: ()=>StandaloneStyleContext_js_namespaceObject.StandaloneStyleProvider,
    TravelBotLogoImage: ()=>external_TravelBotLogoImage_js_namespaceObject.TravelBotLogoImage,
    RequestFromType: ()=>Survey_js_namespaceObject.RequestFromType,
    ScrollIntoView: ()=>external_ScrollIntoView_js_namespaceObject.ScrollIntoView,
    TheChatBot: ()=>external_TheChatBot_js_namespaceObject.TheChatBot,
    ChatUIContext: ()=>ChatUIContext_js_namespaceObject.ChatUIContext,
    useChatUIState: ()=>useChatUIState_js_namespaceObject.useChatUIState,
    BroadcastType: ()=>pennyBroadcast_js_namespaceObject.BroadcastType,
    PennyToolTip: ()=>PennyToolTip_js_default(),
    createPennyBroadcastSubscriber: ()=>pennyBroadcast_js_namespaceObject.createPennyBroadcastSubscriber,
    ChatMessagesProvider: ()=>ChatMessagesProvider_js_namespaceObject.ChatMessagesProvider,
    useChatbotState: ()=>useChatBotState_js_namespaceObject.useChatbotState,
    useSuppressOnNativeWebView: ()=>useSuppressOnNativeWebView_js_namespaceObject.useSuppressOnNativeWebView,
    VoiceControlButton: ()=>VoiceControlButton_js_default(),
    useChatMessagesContext: ()=>useChatMessagesContext_js_namespaceObject.useChatMessagesContext,
    DefaultModalHeader: ()=>DefaultModalHeader_js_namespaceObject.DefaultModalHeader,
    ChatProvider: ()=>ChatProvider_js_namespaceObject.ChatProvider,
    ChatInput: ()=>ChatInput_js_namespaceObject.ChatInput,
    DialogLoading: ()=>external_DialogLoading_js_namespaceObject.DialogLoading,
    ChatMessageErrorBoundary: ()=>ChatMessageErrorBoundary_js_default(),
    TravelBotChatSingleDialogGeneric: ()=>external_TravelBotChatSingleDialogGeneric_js_namespaceObject.TravelBotChatSingleDialogGeneric,
    pennyBroadcast: ()=>pennyBroadcast_js_default(),
    RealTimeProvider: ()=>RealTimeProvider_js_namespaceObject.RealTimeProvider,
    LoadingStateProvider: ()=>LoadingStateProvider_js_namespaceObject.LoadingStateProvider,
    localCache: ()=>external_localMessagsCache_js_namespaceObject.localCache,
    GREETING_MESSAGE: ()=>prompt_js_namespaceObject.GREETING_MESSAGE,
    getLastUserMessageContent: ()=>getLastUserMessage_js_namespaceObject.getLastUserMessageContent,
    ChatBotPopOver: ()=>external_ChatBotPopOver_js_namespaceObject.ChatBotPopOver,
    DialogInputSection: ()=>DialogInputSection_js_namespaceObject.DialogInputSection,
    useSeti: ()=>useSeti_js_namespaceObject.useSeti,
    ChatUIContextProvider: ()=>ChatUIContextProvider_js_namespaceObject.ChatUIContextProvider,
    useStandaloneStyles: ()=>StandaloneStyleContext_js_namespaceObject.useStandaloneStyles,
    ChatMainContentSection: ()=>external_ChatContent_js_default(),
    SignInMarkerComponent: ()=>external_SignInMarkerComponent_js_namespaceObject.SignInMarkerComponent,
    GoogleMapComponents: ()=>GoogleMapComponents_js_default(),
    useChatUIContext: ()=>useChatUIContext_js_namespaceObject.useChatUIContext,
    useLoadingState: ()=>useLoadingState_js_namespaceObject.useLoadingState,
    fetchChatStream: ()=>external_submitChatMessages_js_namespaceObject.fetchChatStream,
    ChatMessagesContext: ()=>ChatMessagesContext_js_namespaceObject.ChatMessagesContext,
    RealTimeAudioPanel: ()=>external_RealTimeAudioPanel_js_default(),
    default: ()=>src,
    ChatbotDataProvider: ()=>ChatbotDataProvider_js_namespaceObject.ChatbotDataProvider,
    useRealTimeContext: ()=>useRealTimeContext_js_namespaceObject.useRealTimeContext,
    submitChatMessages: ()=>external_submitChatMessages_js_namespaceObject.submitChatMessages,
    PennyExpandableInput: ()=>index_js_default(),
    usePennySubscriber: ()=>pennyBroadcast_js_namespaceObject.usePennySubscriber,
    ErrorComponent: ()=>ErrorComponent_index_js_default(),
    usePromptRetrieval: ()=>usePromptRetrieval_js_default(),
    ConfigContext: ()=>ConfigContext_js_namespaceObject.ConfigContext,
    useLoadingStateContext: ()=>useLoadingStateContext_js_namespaceObject.useLoadingStateContext,
    ConfigProvider: ()=>ConfigProvider_js_namespaceObject.ConfigProvider,
    RealTimeContext: ()=>RealTimeContext_js_namespaceObject.RealTimeContext,
    StickyChatBotOpener: ()=>external_StickyChatBotOpener_js_namespaceObject.StickyChatBotOpener,
    ChatbotDataContext: ()=>ChatbotDataContext_js_namespaceObject.ChatbotDataContext,
    Survey: ()=>Survey_js_default(),
    useLoadPreviousPrompts: ()=>useLoadPreviousPrompts_js_default(),
    useConfig: ()=>useConfig_js_namespaceObject.useConfig,
    sanitizeInput: ()=>sanitizeInput_js_default(),
    getLastUserMessage: ()=>getLastUserMessage_js_namespaceObject.getLastUserMessage,
    useChatMessagesState: ()=>useChatMessagesState_js_namespaceObject.useChatMessagesState,
    browserStorageManager: ()=>browserStorage_js_namespaceObject.browserStorageManager,
    QuickActions: ()=>external_QuickActions_js_namespaceObject.QuickActions,
    useRealTimeState: ()=>useRealTimeState_js_namespaceObject.useRealTimeState
});
const external_PclnUcChatBot_js_namespaceObject = require("./PclnUcChatBot.js");
const pennyBroadcast_js_namespaceObject = require("./utils/pennyBroadcast.js");
var pennyBroadcast_js_default = /*#__PURE__*/ __webpack_require__.n(pennyBroadcast_js_namespaceObject);
const ChatbotDataContext_js_namespaceObject = require("./context/ChatbotDataContext.js");
const ChatbotDataProvider_js_namespaceObject = require("./context/ChatbotDataProvider.js");
const external_ChatBotPopOver_js_namespaceObject = require("./ChatBotPopOver.js");
const index_js_namespaceObject = require("./components/PennyExpandableInput/index.js");
var index_js_default = /*#__PURE__*/ __webpack_require__.n(index_js_namespaceObject);
const external_ChatContent_js_namespaceObject = require("./ChatContent.js");
var external_ChatContent_js_default = /*#__PURE__*/ __webpack_require__.n(external_ChatContent_js_namespaceObject);
const DefaultModalHeader_js_namespaceObject = require("./components/Header/DefaultModalHeader.js");
const DialogInputSection_js_namespaceObject = require("./components/ChatInput/DialogInputSection.js");
const external_DialogLoading_js_namespaceObject = require("./DialogLoading.js");
const external_localMessagsCache_js_namespaceObject = require("./localMessagsCache.js");
const external_ScrollIntoView_js_namespaceObject = require("./ScrollIntoView.js");
const external_StickyChatBotOpener_js_namespaceObject = require("./StickyChatBotOpener.js");
const external_SignInMarkerComponent_js_namespaceObject = require("./SignInMarkerComponent.js");
const external_submitChatMessages_js_namespaceObject = require("./submitChatMessages.js");
const external_TravelBotChatSingleDialogGeneric_js_namespaceObject = require("./TravelBotChatSingleDialogGeneric.js");
const external_TravelBotLogoImage_js_namespaceObject = require("./TravelBotLogoImage.js");
const useChatBotState_js_namespaceObject = require("./hooks/useChatBotState.js");
const PennyToolTip_js_namespaceObject = require("./components/Header/PennyToolTip.js");
var PennyToolTip_js_default = /*#__PURE__*/ __webpack_require__.n(PennyToolTip_js_namespaceObject);
const StandaloneStyleContext_js_namespaceObject = require("./context/StandaloneStyleContext.js");
const GoogleMapComponents_js_namespaceObject = require("./components/Maps/GoogleMapComponents.js");
var GoogleMapComponents_js_default = /*#__PURE__*/ __webpack_require__.n(GoogleMapComponents_js_namespaceObject);
const Survey_js_namespaceObject = require("./components/Survey/Survey.js");
var Survey_js_default = /*#__PURE__*/ __webpack_require__.n(Survey_js_namespaceObject);
const VoiceControlButton_js_namespaceObject = require("./components/Realtime/VoiceControlButton/VoiceControlButton.js");
var VoiceControlButton_js_default = /*#__PURE__*/ __webpack_require__.n(VoiceControlButton_js_namespaceObject);
const usePromptRetrieval_js_namespaceObject = require("./hooks/usePromptRetrieval.js");
var usePromptRetrieval_js_default = /*#__PURE__*/ __webpack_require__.n(usePromptRetrieval_js_namespaceObject);
const useLoadPreviousPrompts_js_namespaceObject = require("./hooks/useLoadPreviousPrompts.js");
var useLoadPreviousPrompts_js_default = /*#__PURE__*/ __webpack_require__.n(useLoadPreviousPrompts_js_namespaceObject);
const sanitizeInput_js_namespaceObject = require("./utils/sanitizeInput.js");
var sanitizeInput_js_default = /*#__PURE__*/ __webpack_require__.n(sanitizeInput_js_namespaceObject);
const getLastUserMessage_js_namespaceObject = require("./utils/getLastUserMessage.js");
const ChatMessageErrorBoundary_js_namespaceObject = require("./components/ErrorBoundary/ChatMessageErrorBoundary.js");
var ChatMessageErrorBoundary_js_default = /*#__PURE__*/ __webpack_require__.n(ChatMessageErrorBoundary_js_namespaceObject);
const ErrorComponent_index_js_namespaceObject = require("./components/ErrorComponent/index.js");
var ErrorComponent_index_js_default = /*#__PURE__*/ __webpack_require__.n(ErrorComponent_index_js_namespaceObject);
const external_RealTimeAudioPanel_js_namespaceObject = require("./RealTimeAudioPanel.js");
var external_RealTimeAudioPanel_js_default = /*#__PURE__*/ __webpack_require__.n(external_RealTimeAudioPanel_js_namespaceObject);
const ChatInput_js_namespaceObject = require("./components/ChatInput/ChatInput.js");
const useSuppressOnNativeWebView_js_namespaceObject = require("./hooks/useSuppressOnNativeWebView.js");
const useSeti_js_namespaceObject = require("./utils/useSeti.js");
const external_QuickActions_js_namespaceObject = require("./QuickActions.js");
const prompt_js_namespaceObject = require("./constants/prompt.js");
const useChatMessagesState_js_namespaceObject = require("./hooks/useChatMessagesState.js");
const useChatMessagesContext_js_namespaceObject = require("./hooks/useChatMessagesContext.js");
const ChatMessagesContext_js_namespaceObject = require("./context/ChatMessagesContext.js");
const ChatMessagesProvider_js_namespaceObject = require("./context/ChatMessagesProvider.js");
const useLoadingState_js_namespaceObject = require("./hooks/useLoadingState.js");
const useLoadingStateContext_js_namespaceObject = require("./hooks/useLoadingStateContext.js");
const LoadingStateContext_js_namespaceObject = require("./context/LoadingStateContext.js");
const LoadingStateProvider_js_namespaceObject = require("./context/LoadingStateProvider.js");
const useRealTimeState_js_namespaceObject = require("./hooks/useRealTimeState.js");
const useRealTimeContext_js_namespaceObject = require("./hooks/useRealTimeContext.js");
const RealTimeContext_js_namespaceObject = require("./context/RealTimeContext.js");
const RealTimeProvider_js_namespaceObject = require("./context/RealTimeProvider.js");
const useChatUIState_js_namespaceObject = require("./hooks/useChatUIState.js");
const useChatUIContext_js_namespaceObject = require("./hooks/useChatUIContext.js");
const ChatUIContext_js_namespaceObject = require("./context/ChatUIContext.js");
const ChatUIContextProvider_js_namespaceObject = require("./context/ChatUIContextProvider.js");
const useConfig_js_namespaceObject = require("./hooks/useConfig.js");
const ConfigProvider_js_namespaceObject = require("./context/ConfigProvider.js");
const ConfigContext_js_namespaceObject = require("./context/ConfigContext.js");
const ChatProvider_js_namespaceObject = require("./context/ChatProvider.js");
const browserStorage_js_namespaceObject = require("./utils/browserStorage.js");
const external_TheChatBot_js_namespaceObject = require("./TheChatBot.js");
const src = external_PclnUcChatBot_js_namespaceObject.PclnUcChatBot;
exports.BroadcastType = __webpack_exports__.BroadcastType;
exports.ChatBotPopOver = __webpack_exports__.ChatBotPopOver;
exports.ChatInput = __webpack_exports__.ChatInput;
exports.ChatMainContentSection = __webpack_exports__.ChatMainContentSection;
exports.ChatMessageErrorBoundary = __webpack_exports__.ChatMessageErrorBoundary;
exports.ChatMessagesContext = __webpack_exports__.ChatMessagesContext;
exports.ChatMessagesProvider = __webpack_exports__.ChatMessagesProvider;
exports.ChatProvider = __webpack_exports__.ChatProvider;
exports.ChatUIContext = __webpack_exports__.ChatUIContext;
exports.ChatUIContextProvider = __webpack_exports__.ChatUIContextProvider;
exports.ChatbotDataContext = __webpack_exports__.ChatbotDataContext;
exports.ChatbotDataProvider = __webpack_exports__.ChatbotDataProvider;
exports.ConfigContext = __webpack_exports__.ConfigContext;
exports.ConfigProvider = __webpack_exports__.ConfigProvider;
exports.DefaultModalHeader = __webpack_exports__.DefaultModalHeader;
exports.DialogInputSection = __webpack_exports__.DialogInputSection;
exports.DialogLoading = __webpack_exports__.DialogLoading;
exports.ErrorComponent = __webpack_exports__.ErrorComponent;
exports.GREETING_MESSAGE = __webpack_exports__.GREETING_MESSAGE;
exports.GoogleMapComponents = __webpack_exports__.GoogleMapComponents;
exports.LoadingStateContext = __webpack_exports__.LoadingStateContext;
exports.LoadingStateProvider = __webpack_exports__.LoadingStateProvider;
exports.PennyExpandableInput = __webpack_exports__.PennyExpandableInput;
exports.PennyToolTip = __webpack_exports__.PennyToolTip;
exports.QuickActions = __webpack_exports__.QuickActions;
exports.RealTimeAudioPanel = __webpack_exports__.RealTimeAudioPanel;
exports.RealTimeContext = __webpack_exports__.RealTimeContext;
exports.RealTimeProvider = __webpack_exports__.RealTimeProvider;
exports.RequestFromType = __webpack_exports__.RequestFromType;
exports.ScrollIntoView = __webpack_exports__.ScrollIntoView;
exports.SignInMarkerComponent = __webpack_exports__.SignInMarkerComponent;
exports.StandaloneStyleProvider = __webpack_exports__.StandaloneStyleProvider;
exports.StickyChatBotOpener = __webpack_exports__.StickyChatBotOpener;
exports.Survey = __webpack_exports__.Survey;
exports.TheChatBot = __webpack_exports__.TheChatBot;
exports.TravelBotChatSingleDialogGeneric = __webpack_exports__.TravelBotChatSingleDialogGeneric;
exports.TravelBotLogoImage = __webpack_exports__.TravelBotLogoImage;
exports.VoiceControlButton = __webpack_exports__.VoiceControlButton;
exports.browserStorageManager = __webpack_exports__.browserStorageManager;
exports.createPennyBroadcastSubscriber = __webpack_exports__.createPennyBroadcastSubscriber;
exports["default"] = __webpack_exports__["default"];
exports.fetchChatStream = __webpack_exports__.fetchChatStream;
exports.getLastUserMessage = __webpack_exports__.getLastUserMessage;
exports.getLastUserMessageContent = __webpack_exports__.getLastUserMessageContent;
exports.localCache = __webpack_exports__.localCache;
exports.pennyBroadcast = __webpack_exports__.pennyBroadcast;
exports.sanitizeInput = __webpack_exports__.sanitizeInput;
exports.submitChatMessages = __webpack_exports__.submitChatMessages;
exports.useChatMessagesContext = __webpack_exports__.useChatMessagesContext;
exports.useChatMessagesState = __webpack_exports__.useChatMessagesState;
exports.useChatUIContext = __webpack_exports__.useChatUIContext;
exports.useChatUIState = __webpack_exports__.useChatUIState;
exports.useChatbotState = __webpack_exports__.useChatbotState;
exports.useConfig = __webpack_exports__.useConfig;
exports.useLoadPreviousPrompts = __webpack_exports__.useLoadPreviousPrompts;
exports.useLoadingState = __webpack_exports__.useLoadingState;
exports.useLoadingStateContext = __webpack_exports__.useLoadingStateContext;
exports.usePennySubscriber = __webpack_exports__.usePennySubscriber;
exports.usePromptRetrieval = __webpack_exports__.usePromptRetrieval;
exports.useRealTimeContext = __webpack_exports__.useRealTimeContext;
exports.useRealTimeState = __webpack_exports__.useRealTimeState;
exports.useSeti = __webpack_exports__.useSeti;
exports.useStandaloneStyles = __webpack_exports__.useStandaloneStyles;
exports.useSuppressOnNativeWebView = __webpack_exports__.useSuppressOnNativeWebView;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "BroadcastType",
    "ChatBotPopOver",
    "ChatInput",
    "ChatMainContentSection",
    "ChatMessageErrorBoundary",
    "ChatMessagesContext",
    "ChatMessagesProvider",
    "ChatProvider",
    "ChatUIContext",
    "ChatUIContextProvider",
    "ChatbotDataContext",
    "ChatbotDataProvider",
    "ConfigContext",
    "ConfigProvider",
    "DefaultModalHeader",
    "DialogInputSection",
    "DialogLoading",
    "ErrorComponent",
    "GREETING_MESSAGE",
    "GoogleMapComponents",
    "LoadingStateContext",
    "LoadingStateProvider",
    "PennyExpandableInput",
    "PennyToolTip",
    "QuickActions",
    "RealTimeAudioPanel",
    "RealTimeContext",
    "RealTimeProvider",
    "RequestFromType",
    "ScrollIntoView",
    "SignInMarkerComponent",
    "StandaloneStyleProvider",
    "StickyChatBotOpener",
    "Survey",
    "TheChatBot",
    "TravelBotChatSingleDialogGeneric",
    "TravelBotLogoImage",
    "VoiceControlButton",
    "browserStorageManager",
    "createPennyBroadcastSubscriber",
    "default",
    "fetchChatStream",
    "getLastUserMessage",
    "getLastUserMessageContent",
    "localCache",
    "pennyBroadcast",
    "sanitizeInput",
    "submitChatMessages",
    "useChatMessagesContext",
    "useChatMessagesState",
    "useChatUIContext",
    "useChatUIState",
    "useChatbotState",
    "useConfig",
    "useLoadPreviousPrompts",
    "useLoadingState",
    "useLoadingStateContext",
    "usePennySubscriber",
    "usePromptRetrieval",
    "useRealTimeContext",
    "useRealTimeState",
    "useSeti",
    "useStandaloneStyles",
    "useSuppressOnNativeWebView"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
